import { makeAutoObservable, runInAction } from "mobx";
import { Store, AllLeaguesData, ILeagueStore, LeagueDetails, AllLeagueMembers, AllLeagueAssurancesHistory } from "../global/types";
import { getLeagueDetails, getAllLeaguesData, getLeagueStats, getLeagueAssurancesHistory } from "../api/user.action"

class LeagueStore implements ILeagueStore {
    rootStore: Store;
    allLeaguesData: AllLeaguesData[] = [];
    leaguesData: AllLeaguesData | null = null;
    leagueDetails: LeagueDetails | null = null;
    leagueMembers: AllLeagueMembers[] = []
    leagueAssurancesHistory: AllLeagueAssurancesHistory[] = []
    minutesGained: number = 0
    minutesMissed: number = 0
    error: string | null = null;
    loading: boolean = false;
    page: number = 1;
    searchTerm: string = '';
    limit: number = 10;
    totalItems: number = 0;
    totalPages: number = 0;
    leagueFocus: number = 1;
    leagueFilter: number = 1;

    constructor(rootStore: Store) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setLoading = (loading: boolean) => {
        this.loading = loading;
    }

    fetchAllLeaguesData = async (
        action: 'change_page' | 'search' | 'change_limit' | 'change_filter' | '',
        page: number,
        searchTerm: string,
        limit: number
    ) => {
        this.setLoading(true);
        try {
            runInAction(() => {
                switch (action) {
                    case 'change_page':
                        this.page = page;
                        break;
                    case 'search':
                        this.searchTerm = searchTerm;
                        this.page = 1;
                        break;
                    case 'change_limit':
                        this.limit = limit
                        this.page = 1
                        break;
                    default:
                        break;
                }
            })
            const data = {
                page: this.page,
                limit: this.limit,
                search: this.searchTerm?.trim()
            }
            const response = await getAllLeaguesData(data);
            runInAction(() => {
                this.allLeaguesData = response.data?.leagues || [];
                this.totalItems = response.data?.totalItems;
                this.totalPages = response.data?.totalPages;
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    fetchLeagueDetails = async(id: string, date_filter?: number) => {
        this.setLoading(true);
        try {
            const response = await getLeagueDetails(id, date_filter)
            runInAction(() => {
                this.leagueDetails = response.data?.league || [];
                this.leaguesData = response.data.league
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    fetchLeagueAssurancesHistory = async(id: string) => {
        this.setLoading(true);
        try {
            const response = await getLeagueAssurancesHistory(id)
            runInAction(() => {
                this.leagueAssurancesHistory = response.data?.leagueAssurancesHistory || []
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    fetchLeagueStats = async(id: string, date_filter?: number, league_focus?: number) => {
        this.setLoading(true);
        try {
            const response = await getLeagueStats(id, date_filter, league_focus)
            runInAction(() => {
                this.leagueMembers = response.data.members || []
                this.minutesGained = response.data.minutesGained
                this.minutesMissed = response.data.minutesMissed
            })
            this.leagueFilter = date_filter || 1
            this.leagueFocus = league_focus || 1
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    fetchOneLeagueData = async (id: string) => {
        this.setLoading(true);
        try {

        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    resetLeaguePageDataStates = () => {
        runInAction(() => {
            this.allLeaguesData = [];
            this.leaguesData = null;
            this.leagueMembers = [];
            this.minutesGained = 0;
            this.error = null;
            this.loading = false;
            this.page = 1;
            this.searchTerm = '';
            this.limit = 10;
            this.totalItems = 0;
            this.totalPages = 0;
            this.leagueFocus = 1;
            this.leagueFilter = 1;
        })
    }
}

export default LeagueStore;
